import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import ButtonMain from "../ui/ButtonMain";
import translation from "../data/fa-IR.json";

interface OnlineClassPurchaseResultProps {
  status: "success" | "error";
}

function OnlineClassPurchaseResult({ status }: OnlineClassPurchaseResultProps) {
  const { classId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["my-online-class", classId] });
    queryClient.invalidateQueries({ queryKey: ["online-class", classId] });
    queryClient.invalidateQueries({ queryKey: ["online-classes"] });
    queryClient.invalidateQueries({ queryKey: ["my-online-classes"] });
    navigate(`/online-classes/class/${classId}`, { replace: true });
  }, [status, classId, navigate, queryClient]);

  return null;
}

export default OnlineClassPurchaseResult;